import { Trans, useLingui } from "@lingui/react";
import { TradeOrgPages } from "src/types/tradeorgPages.ts";
import List from "./components/List.tsx";
import OrgLinks from "./components/OrgLinks.tsx";
import Title from "./components/Title.tsx";
import { Layout } from "./Layout.tsx";

const Nmcf = () => {
  const { i18n } = useLingui();
  const pageName = TradeOrgPages.NMCF;

  const pageTitle = i18n._({
    id: "tradeOrgLayout.page.title",
    message: "Advantages with {tradeOrgName}",
    comment: "Page title with trade organization name",
    values: { tradeOrgName: pageName.toUpperCase() },
  });

  const subTitle = i18n._({
    id: "tradeOrgLayout.nmcf.subtitle.text",
    message: "This bike is sold by a member of the Norwegian MC Dealers Association",
    comment: "Do not edit the translation submitted. Pre-approved text, must not deviate.",
  });

  const advantagesList = [
    i18n.t({
      id: "tradeOrgLayout.nmcf.section.one.advantages.itemOne",
      message: "The motorcycle has been inspected and your safety is taken care of",
      comment: "Do not edit the translation submitted. Pre-approved text, must not deviate.",
    }),
    i18n.t({
      id: "tradeOrgLayout.nmcf.section.one.advantages.itemTwo",
      message: "The motorcycle has NMCF's vehicle inspection (condition report)",
      comment: "Do not edit the translation submitted. Pre-approved text, must not deviate.",
    }),
    i18n.t({
      id: "tradeOrgLayout.nmcf.section.one.advantages.itemThree",
      message: "The motorcycle is delivered with a warranty",
      comment: "Do not edit the translation submitted. Pre-approved text, must not deviate.",
    }),
    i18n.t({
      id: "tradeOrgLayout.nmcf.section.one.advantages.itemFour",
      message: "The motorcycle has a mileage warranty",
      comment: "Do not edit the translation submitted. Pre-approved text, must not deviate.",
    }),
    i18n.t({
      id: "tradeOrgLayout.nmcf.section.one.advantages.itemFive",
      message: "The motorcycle is free of liens",
      comment: "Do not edit the translation submitted. Pre-approved text, must not deviate.",
    }),
    i18n.t({
      id: "tradeOrgLayout.nmcf.section.one.advantages.itemSix",
      message: "The dealer guarantees the correct service history",
      comment: "Do not edit the translation submitted. Pre-approved text, must not deviate.",
    }),
    i18n.t({
      id: "tradeOrgLayout.nmcf.section.one.advantages.itemSeven",
      message: "Exchange of your old motorcycle and favorable financing",
      comment: "Do not edit the translation submitted. Pre-approved text, must not deviate.",
    }),
    i18n.t({
      id: "tradeOrgLayout.nmcf.section.one.advantages.itemEight",
      message: "The Consumer Purchase Act applies and is followed for consumer purchases",
      comment: "Do not edit the translation submitted. Pre-approved text, must not deviate.",
    }),
    i18n.t({
      id: "tradeOrgLayout.nmcf.section.one.advantages.itemNine",
      message: "Purchase agreement in accordance with the Consumer Purchase Act and NMCF's authorization",
      comment: "Do not edit the translation submitted. Pre-approved text, must not deviate.",
    }),
    i18n.t({
      id: "tradeOrgLayout.nmcf.section.one.advantages.itemTen",
      message: "You can use the NMCF / NMCU's own dispute resolution in the event of disputes",
      comment: "Do not edit the translation submitted. Pre-approved text, must not deviate.",
    }),
  ];

  const listTitle = i18n.t({
    id: "tradeOrgLayout.nmcf.section.one.title",
    message: "When you buy a motorcycle from an authorized NMCF dealer, you get:",
    comment: "Do not edit the translation submitted. Pre-approved text, must not deviate.",
  });

  return (
    <Layout
      left={
        <>
          <Title title={pageTitle} subTitle={subTitle} />

          <div className="mt-40">
            <List title={listTitle} listElements={advantagesList} />

            <div className="mt-40 pb-40 border-b md:border-none">
              <h4 className="t4 mb-0">
                <Trans
                  id="tradeOrgLayout.nmcf.section.two.title"
                  message="Buy a motorcycle from an NMCF specialist dealer:"
                  comment="Do not edit the translation submitted. Pre-approved text, must not deviate."
                />
              </h4>

              <p className="mt-16 mb-0">
                <Trans
                  id="tradeOrgLayout.nmcf.section.two.text"
                  message="This gives you peace of mind when buying a used motorcycle.
Look for motorcycles with NMCF vehicle inspection (FKK) with warranty. NMCF's vehicle inspection is only valid when it is marked with the NMCF member's authorization number."
                  comment="Do not edit the translation submitted. Pre-approved text, must not deviate."
                />
              </p>

              <p className="mt-16 mb-0 text-m">
                <a href="https://www.nmcf.no/autorisasjon/" target="_blank" rel="noopener">
                  <Trans
                    id="tradeOrgLayout.nmcf.section.two.link"
                    message="Read more about NMCF Authorization"
                    comment="Do not edit the translation submitted. Pre-approved text, must not deviate."
                  />
                </a>
              </p>

              <h4 className="t4 mt-40 mb-0">
                <Trans
                  id="tradeOrgLayout.nmcf.section.three.title"
                  message="NMCF membership obliges"
                  comment="Do not edit the translation submitted. Pre-approved text, must not deviate."
                />
              </h4>

              <p className="mt-16 mb-0">
                <Trans
                  id="tradeOrgLayout.nmcf.section.three.text.partOne"
                  message="Always look for motorcycles with the NMCF condition report, marked with the NMCF member's authorization number."
                  comment="Do not edit the translation submitted. Pre-approved text, must not deviate."
                />
              </p>

              <p className="mt-16 mb-0">
                <Trans
                  id="tradeOrgLayout.nmcf.section.three.text.partTwo"
                  message="The NMCF dealers have a varied offer of used motorcycles in all price ranges and can also help you if you have special wishes or requirements. An NMCF specialist dealer helps you to choose the right one for your needs and level!"
                  comment="Do not edit the translation submitted. Pre-approved text, must not deviate."
                />
              </p>

              <p className="mt-16 mb-0">
                <Trans
                  id="tradeOrgLayout.nmcf.section.three.text.partThree"
                  message="Visit an NMCF dealer for your next motorcycle purchase!"
                  comment="Do not edit the translation submitted. Pre-approved text, must not deviate."
                />
              </p>

              <p className="mt-16 mb-0 text-m">
                <a href="https://www.nmcf.no/autorisasjon/" target="_blank" rel="noopener">
                  <Trans
                    id="tradeOrgLayout.nmcf.section.three.link"
                    message="FIND your local NMCF dealer"
                    comment="Do not edit the translation submitted. Pre-approved text, must not deviate."
                  />
                </a>
              </p>
            </div>
          </div>
        </>
      }
      right={<OrgLinks pageName={pageName} />}
    />
  );
};

export default Nmcf;
